import { FileUploadOutput } from '@zonofi/zono-money-store';
import { ActionListView } from '../action-view';
import { BottomModal } from '../bottom-modal';
import { MediaActiveModal } from '../../types';

interface MediaModalGroupProps {
  activeModal: MediaActiveModal;
  selectedMediaItem?: FileUploadOutput;
  onClose: () => void;
  mediaActions: any[];
  uploadMediaActions: any[];
}

export const MediaModalGroup: React.FC<MediaModalGroupProps> = ({
  activeModal,
  selectedMediaItem,
  onClose,
  mediaActions,
  uploadMediaActions,
}) => {
  const isActionModal =
    activeModal === 'MEDIA_ACTIONS' || activeModal === 'IMAGE_PREVIEW';
  const isUploadModal = activeModal === 'MEDIA_UPLOAD';
  const shouldShowFile = activeModal === 'IMAGE_PREVIEW';

  return (
    <>
      <BottomModal
        isVisible={isActionModal}
        title="Actions"
        leftText="Close"
        onLeftAction={onClose}
        onRightAction={onClose}
        modalChildrenStyles={{ backgroundColor: '#f0f0f0' }}
        showDivider
        leftTextStyle="close-text"
      >
        <ActionListView
          actions={mediaActions}
          shouldShowFile={shouldShowFile}
          selectedMediaItem={selectedMediaItem}
        />
      </BottomModal>

      <BottomModal
        isVisible={isUploadModal}
        title="Actions"
        leftText="Close"
        onLeftAction={onClose}
        onRightAction={onClose}
        modalChildrenStyles={{ backgroundColor: '#f0f0f0' }}
        showDivider
        leftTextStyle="close-text"
      >
        <ActionListView actions={uploadMediaActions} />
      </BottomModal>
    </>
  );
};
